import React from 'react'

import LABEL from '../../business-const/Label/Label'

import {
    GridContainer,
    GridItem12,
} from '../../business-components/Grid/Grid'

import {
    IconButtonExcel,
} from '../IconButton/IconButton'

import {
    exportToExcel
} from './ExcelService'



export const ExportExcel = ({ listExcel, nomeArquivoExcel }) => {

    return (
        <IconButtonExcel
            tooltipTitle={LABEL.exportarDadosExcel}
            onClick={
                async (e) => await exportToExcel(listExcel, nomeArquivoExcel)
            }
        />
    )
}

export const ExportExcelRight = ({ listExcel, nomeArquivoExcel }) => {

    return (
        <GridContainer>
            <GridItem12
                align="right"
            >
                <ExportExcel
                    listExcel={listExcel}
                    nomeArquivoExcel={nomeArquivoExcel}
                />
            </GridItem12>
        </GridContainer>
    )
}

/* Exemplo de uso
<ExportExcel
    listExcel={preparaExportacaoExcel(list, dashboard, filtroLists, variaveisGlobais, camposList)}
    nomeArquivoExcel={nomeArquivoExcel}
/>
*/